var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFrame214(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    rx: 30,
    fill: "#20A3BA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.92 18.24H23.88V27.36C24.4933 26.5067 25.4 25.8133 26.6 25.28C27.8 24.72 29.0933 24.44 30.48 24.44C32.6933 24.44 34.4933 24.9067 35.88 25.84C37.2667 26.7467 38.2533 27.9333 38.84 29.4C39.4533 30.84 39.76 32.3733 39.76 34C39.76 35.92 39.4 37.64 38.68 39.16C37.96 40.68 36.8533 41.88 35.36 42.76C33.8933 43.64 32.0667 44.08 29.88 44.08C27.08 44.08 24.8133 43.36 23.08 41.92C21.3467 40.48 20.2933 38.56 19.92 36.16H23.48C23.8267 37.68 24.56 38.8667 25.68 39.72C26.8 40.5733 28.2133 41 29.92 41C32.0267 41 33.6133 40.3733 34.68 39.12C35.7467 37.84 36.28 36.16 36.28 34.08C36.28 32 35.7467 30.4 34.68 29.28C33.6133 28.1333 32.04 27.56 29.96 27.56C28.5467 27.56 27.3067 27.9067 26.24 28.6C25.2 29.2667 24.44 30.1867 23.96 31.36H20.52V15.04H37.92V18.24Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame214);
export default __webpack_public_path__ + "static/media/Frame 21 (4).221a22a93f4c9a4b4f176eeda4b006f5.svg";
export { ForwardRef as ReactComponent };